import { Icon, Paragraph } from '@zillow/constellation-10';
import { IconArchiveFilled, IconSpamFolderFilled } from '@zillow/constellation-icons';
import { MESSAGE_LOAD_ERROR_TEXT } from '../../constants';
import type { ConversationItemProps } from './index';

type MessageContentProps = Pick<
  ConversationItemProps,
  'isPhoneLead' | 'isMessageOwner' | 'latestMessage' | 'isArchived' | 'isSpamOrReported'
>;

export default function MessageContent({
  isPhoneLead,
  isMessageOwner,
  latestMessage,
  isArchived,
  isSpamOrReported,
}: MessageContentProps) {
  if (!latestMessage && !isPhoneLead) {
    return <Paragraph>({MESSAGE_LOAD_ERROR_TEXT})</Paragraph>;
  }

  return (
    <Paragraph css={{ truncate: 'end' }}>
      {isArchived && <Icon render={<IconArchiveFilled />} size="sm" css={{ marginRight: 'tighter' }} />}
      {isSpamOrReported && <Icon render={<IconSpamFolderFilled />} size="sm" css={{ marginRight: 'tighter' }} />}
      {isPhoneLead ? '(Phone lead)' : `${isMessageOwner ? 'You: ' : ''}${latestMessage}`}
    </Paragraph>
  );
}
